/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, MenuItem } from '@mui/material';

import { CopyToClipboard } from '../../../../../../components/CopyToClipboard/component';
import { Namespaces } from '../../../../../../i18n';

type WidgetMenuProps = {
  menuAnchor: null | HTMLElement;
  menuClose: () => void;
  propName: string | null;
  propValue: string | null;
  onCopy?: () => void;
};

export function WidgetMenu(props: WidgetMenuProps) {
  const { menuAnchor, menuClose, propName, propValue, onCopy } = props;

  const { t } = useTranslation(Namespaces.Cluster);

  return (
    <Menu id="menu" anchorEl={menuAnchor} keepMounted open={Boolean(menuAnchor)} onClose={menuClose}>
      {!!propName && (
        <CopyToClipboard text={propName} onCopy={onCopy}>
          <MenuItem>{t('details.parameters.field_menu.copy_prop_name')}</MenuItem>
        </CopyToClipboard>
      )}
      {!!propValue && (
        <CopyToClipboard text={propValue} onCopy={onCopy}>
          <MenuItem>{t('details.parameters.field_menu.copy_prop_value')}</MenuItem>
        </CopyToClipboard>
      )}
    </Menu>
  );
}
